import FormatAlignJustifyIcon        from '@material-ui/icons/FormatAlignJustify'
import FormatAlignCenterIcon         from '@material-ui/icons/FormatAlignCenter'
import FormatAlignRightIcon          from '@material-ui/icons/FormatAlignRight'
import FormatUnderlinedIcon          from '@material-ui/icons/FormatUnderlined'
import FormatAlignLeftIcon           from '@material-ui/icons/FormatAlignLeft'
import FormatColorFillIcon           from '@material-ui/icons/FormatColorFill'
import ToggleButtonGroup             from '@material-ui/lab/ToggleButtonGroup'
import ArrowDropDownIcon             from '@material-ui/icons/ArrowDropDown'
import FormatItalicIcon              from '@material-ui/icons/FormatItalic'
import FormatBoldIcon                from '@material-ui/icons/FormatBold'
import ToggleButton                  from '@material-ui/lab/ToggleButton'
import {makeStyles, withStyles}      from '@material-ui/core/styles'
import Paper                         from '@material-ui/core/Paper'
import React, { Fragment, useState } from 'react'

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        flexWrap: 'wrap',
        borderBottomRightRadius: '0',
        borderBottomLeftRadius: '0',
        borderBottom: '0',
    },
    divider: {
        margin: theme.spacing(1, 0.5),
    },
}));

const StyledToggleButtonGroup = withStyles((theme) => ({
    grouped: {
        margin: theme.spacing(0.5),
        border: 'none',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,

        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
    },
}))(ToggleButtonGroup);

export default function Tooglebuttonoptions() {
    const [alignment, setAlignment] = useState('left');

    const classes = useStyles();

    return (
        <Fragment>
            <Paper elevation={0} className={classes.paper}>
                <StyledToggleButtonGroup
                    size="small"
                    value={alignment}
                    exclusive
                    onChange={(event, newAlignment) => setAlignment(newAlignment)}
                    aria-label="text alignment"
                >
                    <ToggleButton value="left" aria-label="left aligned">
                        <FormatAlignLeftIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="center" aria-label="centered">
                        <FormatAlignCenterIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="right" aria-label="right aligned">
                        <FormatAlignRightIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="justify" aria-label="justified">
                        <FormatAlignJustifyIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="bold" aria-label="bold">
                        <FormatBoldIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="italic" aria-label="italic">
                        <FormatItalicIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="underlined" aria-label="underlined">
                        <FormatUnderlinedIcon fontSize="small"/>
                    </ToggleButton>

                    <ToggleButton value="color" aria-label="color">
                        <FormatColorFillIcon fontSize="small"/>
                        <ArrowDropDownIcon fontSize="small"/>
                    </ToggleButton>
                    
                </StyledToggleButtonGroup>
            </Paper>
        </Fragment>
    );
}